import { TableFormater } from '@lib/Helpers'
import { DeliveryShared } from '@shared/Pages'
import { IMediaDelivery } from '@shared/Types'
import { CreateTableTemplate, MapOprators } from '@lib/Table'

export const GetTable = () => {
  return CreateTableTemplate<IMediaDelivery>('Redux', {
    getRowId: (x) => x.Id,
    config: {
      Name: { type: 'string', flex: 2, minWidth: 150, sortable: false },
      Email: { type: 'string', flex: 1, sortable: false, minWidth: 200, headerName: 'Submission', renderCell: (x) => TableFormater.noData(x.value) },
      Title: { type: 'string', flex: 1, sortable: false, minWidth: 150, renderCell: (x) => TableFormater.noData(x.value) },
      Description: { type: 'string', flex: 1, minWidth: 150, renderCell: (param) => TableFormater.tooltipHelp(param.value, 18) },
      TotalItems: { type: 'string', minWidth: 75, sortable: false, filterable: false, headerName: 'Count' },
      MediaType: {
        type: 'string',
        headerName: 'Types',
        minWidth: 150,
        filterable: false,
        sortable: false,
        renderCell: DeliveryShared.renderCellTypeChips()
      },
      DateCreated: { type: 'string', minWidth: 175, filterable: false, renderCell: (params) => TableFormater.tooltipDate(params.value) },
      Status: {
        type: 'string',
        minWidth: 120,
        filterable: false,
        renderCell: (param) => <DeliveryShared.UIStatusCell data={(param.row as IMediaDelivery).Status} />
      }
    },
    filterOperators: MapOprators, //server mode,
    minWidthColumnActions: 100
  })
}
